export enum TaskType {
  FcdImportTask = 'FcdImportTask'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/tasktype.ts